module.exports = __webpack_public_path__ + "static/media/ContactUs@2x.1b5366a7.jpg";